import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PromoCodeSection = ({ onApplyPromo, appliedPromo, discount }) => {
  const [promoCode, setPromoCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setError('Please enter a promo code');
      return;
    }

    setIsLoading(true);
    setError('');

    // Simulate API call
    setTimeout(() => {
      const validCodes = {
        'SAVE10': { discount: 10, type: 'percentage' },
        'FRESH20': { discount: 20, type: 'percentage' },
        'WELCOME5': { discount: 5, type: 'fixed' },
        'NEWUSER': { discount: 15, type: 'percentage' }
      };

      if (validCodes[promoCode.toUpperCase()]) {
        onApplyPromo(promoCode.toUpperCase(), validCodes[promoCode.toUpperCase()]);
        setPromoCode('');
        setError('');
      } else {
        setError('Invalid promo code. Please try again.');
      }
      setIsLoading(false);
    }, 1000);
  };

  const handleRemovePromo = () => {
    onApplyPromo(null, null);
    setError('');
  };

  return (
    <div className="bg-surface border border-border rounded-card p-4 mb-6">
      <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-4">
        Promo Code
      </h3>

      {appliedPromo ? (
        <div className="flex items-center justify-between p-3 bg-success bg-opacity-10 border border-success rounded-input">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={20} className="text-success" />
            <div>
              <span className="font-body-semibold text-success">{appliedPromo}</span>
              <p className="text-sm text-text-secondary">
                {discount.type === 'percentage' 
                  ? `${discount.discount}% discount applied`
                  : `$${discount.discount.toFixed(2)} discount applied`
                }
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            onClick={handleRemovePromo}
            className="text-error hover:text-error"
            iconName="X"
            iconSize={16}
          />
        </div>
      ) : (
        <div className="space-y-3">
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="flex-1">
              <Input
                type="text"
                placeholder="Enter promo code"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                className="w-full"
                disabled={isLoading}
              />
            </div>
            <Button
              variant="primary"
              onClick={handleApplyPromo}
              disabled={isLoading || !promoCode.trim()}
              loading={isLoading}
              className="sm:w-auto"
            >
              Apply
            </Button>
          </div>

          {error && (
            <div className="flex items-center space-x-2 text-error">
              <Icon name="AlertCircle" size={16} />
              <span className="text-sm">{error}</span>
            </div>
          )}

          {/* Available Promo Codes Hint */}
          <div className="text-xs text-text-secondary">
            <p className="mb-1">Available codes:</p>
            <div className="flex flex-wrap gap-2">
              <span className="bg-background px-2 py-1 rounded-input">SAVE10</span>
              <span className="bg-background px-2 py-1 rounded-input">FRESH20</span>
              <span className="bg-background px-2 py-1 rounded-input">WELCOME5</span>
              <span className="bg-background px-2 py-1 rounded-input">NEWUSER</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromoCodeSection;